import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
  faSpinnerThird,
  faPhone,
  faCompass,
  faEnvelope,
  faClock,
  faOven,
  faSearch,
  faLongArrowLeft,
  faLongArrowRight,
  faLongArrowDown
} from "@fortawesome/pro-solid-svg-icons";
import {
  faLinkedin,
  faTwitter,
  faFacebookF,
  faInstagram,
  faWhatsapp,
  faYoutube,
  faLinkedinIn,
  faFacebookMessenger
} from "@fortawesome/free-brands-svg-icons";
library.add(
  faSpinnerThird,
  faPhone,
  faCompass,
  faEnvelope,
  faClock,
  faOven,
  faSearch,
  faLongArrowLeft,
  faLongArrowRight,
  faLongArrowDown,
  faLinkedin,
  faTwitter,
  faFacebookF,
  faInstagram,
  faWhatsapp,
  faYoutube,
  faLinkedinIn,
  faFacebookMessenger
);
dom.watch();
